module.exports = __webpack_public_path__ + "static/media/homeIntro_2.c7f40eb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homeIntro_2.png
// module id = 678
// module chunks = 0